export const categories = [
  { slug: "movie", name: "电影", icon: "ri-film-line" },
  { slug: "tv", name: "电视剧", icon: "ri-tv-line" },
  { slug: "variety", name: "综艺", icon: "ri-live-line" },
  { slug: "anime", name: "动漫", icon: "ri-rocket-line" },
];

export const genres = [
  "动作", "喜剧", "爱情", "科幻", "恐怖", "悬疑", "犯罪", "战争",
  "奇幻", "动画", "纪录片", "历史", "武侠", "家庭", "冒险",
];

export const regions = [
  { slug: "mainland", name: "中国大陆" },
  { slug: "hongkong", name: "中国香港" },
  { slug: "taiwan", name: "中国台湾" },
  { slug: "korea", name: "韩国" },
  { slug: "japan", name: "日本" },
  { slug: "america", name: "美国" },
  { slug: "europe", name: "欧洲" },
  { slug: "other", name: "其他地区" },
];

export const years = ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2010-2019", "2000-2009", "更早"];

export const movies = [
  {
    id: 1,
    title: "流浪地球3",
    originalTitle: "The Wandering Earth 3",
    category: "movie",
    genres: ["科幻", "冒险", "灾难"],
    region: "中国大陆",
    year: "2026",
    rating: 9.2,
    duration: "148分钟",
    director: "郭帆",
    actors: ["吴京", "刘德华", "李雪健"],
    poster: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20style%2C%20astronaut%20in%20space%20suit%20looking%20at%20earth%20from%20space%2C%20dramatic%20lighting%2C%20cinematic%20poster%20design%2C%20warm%20orange%20and%20deep%20black%20tones%2C%20epic%20scale%2C%20movie%20poster%20aesthetic%2C%20clean%20background%20with%20stars&width=600&height=800&seq=movie-poster-01&orientation=portrait",
    description: "太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的宇宙旅程，人类命运共同体将面临前所未有的挑战。在这个关乎存亡的时刻，每一个选择都将决定人类的未来。",
    featured: true,
    hot: true,
    updateDate: "2026-07-28",
  },
  {
    id: 2,
    title: "哪吒之魔童闹海",
    originalTitle: "Nezha 2",
    category: "movie",
    genres: ["动画", "奇幻", "冒险"],
    region: "中国大陆",
    year: "2025",
    rating: 9.5,
    duration: "144分钟",
    director: "饺子",
    actors: ["吕艳婷", "囧森瑟夫", "瀚墨"],
    poster: "https://readdy.ai/api/search-image?query=Chinese%20animation%20fantasy%20movie%20poster%2C%20mythological%20warrior%20with%20flaming%20wheels%20and%20red%20sash%2C%20dynamic%20action%20pose%2C%20vibrant%20red%20and%20gold%20colors%2C%20Chinese%20ink%20painting%20style%20background%2C%20epic%20cinematic%20poster&width=600&height=800&seq=movie-poster-02&orientation=portrait",
    description: "天劫之后，哪吒和敖丙的灵魂得以保留，但他们的肉身即将魂飞魄散。太乙真人打算用七色宝莲给二人重塑肉身，然而在这个过程中却遭遇了前所未有的困难。哪吒与敖丙将如何面对命运的考验？",
    featured: true,
    hot: true,
    updateDate: "2026-07-30",
  },
  {
    id: 3,
    title: "封神第二部：战火西岐",
    originalTitle: "Creation of the Gods II",
    category: "movie",
    genres: ["奇幻", "战争", "动作"],
    region: "中国大陆",
    year: "2025",
    rating: 8.8,
    duration: "145分钟",
    director: "乌尔善",
    actors: ["费翔", "黄渤", "于适"],
    poster: "https://readdy.ai/api/search-image?query=Chinese%20mythological%20war%20epic%20movie%20poster%2C%20ancient%20Chinese%20warriors%20in%20armor%20riding%20horses%20into%20battle%2C%20dramatic%20sky%20with%20fire%20and%20smoke%2C%20bronze%20and%20gold%20color%20scheme%2C%20cinematic%20blockbuster%20poster&width=600&height=800&seq=movie-poster-03&orientation=portrait",
    description: "殷商大军兵临西岐城下，姜子牙与姬发率领西岐军民奋起抵抗。在这场决定天下命运的战争中，封神榜的真相逐渐浮出水面。",
    featured: true,
    hot: false,
    updateDate: "2026-07-15",
  },
  {
    id: 4,
    title: "热辣滚烫",
    originalTitle: "YOLO",
    category: "movie",
    genres: ["喜剧", "剧情"],
    region: "中国大陆",
    year: "2024",
    rating: 8.5,
    duration: "129分钟",
    director: "贾玲",
    actors: ["贾玲", "雷佳音", "张小斐"],
    poster: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%2C%20woman%20boxing%20training%20in%20gym%2C%20inspiring%20transformation%20story%2C%20warm%20lighting%2C%20motivational%20theme%2C%20clean%20poster%20with%20red%20and%20warm%20tones&width=600&height=800&seq=movie-poster-04&orientation=portrait",
    description: "宅女乐莹毕业后一直待业在家，在经历了一系列挫折后，她决定改变自己，开始练习拳击。在这个过程中，她重新找回了生活的意义和勇气。",
    featured: false,
    hot: true,
    updateDate: "2026-07-20",
  },
  {
    id: 5,
    title: "狂飙",
    originalTitle: "The Knockout",
    category: "tv",
    genres: ["犯罪", "剧情"],
    region: "中国大陆",
    year: "2023",
    rating: 9.4,
    duration: "39集",
    director: "徐纪周",
    actors: ["张译", "张颂文", "李一桐"],
    poster: "https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%2C%20two%20men%20in%20suits%20standing%20back%20to%20back%2C%20police%20and%20gangster%20theme%2C%20dark%20and%20moody%20lighting%2C%20urban%20night%20cityscape%20background%2C%20dramatic%20cinematic%20poster&width=600&height=800&seq=movie-poster-05&orientation=portrait",
    description: "讲述了以一线刑警安欣为代表的正义力量，与以高启强为代表的黑恶势力展开的长达二十年的生死较量。通过群像叙事展现扫黑行动中的复杂人性。",
    featured: false,
    hot: true,
    updateDate: "2026-07-25",
  },
  {
    id: 6,
    title: "三体",
    originalTitle: "Three-Body",
    category: "tv",
    genres: ["科幻", "悬疑", "剧情"],
    region: "中国大陆",
    year: "2023",
    rating: 8.9,
    duration: "30集",
    director: "杨磊",
    actors: ["张鲁一", "于和伟", "陈瑾"],
    poster: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%2C%20mysterious%20radio%20telescope%20pointing%20at%20starry%20sky%2C%20three%20suns%20phenomenon%2C%20cosmic%20scale%2C%20blue%20and%20dark%20tones%2C%20atmospheric%20and%20mysterious%20poster&width=600&height=800&seq=movie-poster-06&orientation=portrait",
    description: "纳米科学家汪淼被警官史强带入联合作战中心，潜入科学边界组织协助调查。在调查过程中，汪淼接触到一个名为三体的神秘组织，发现地球基础科学正面临前所未有的危机。",
    featured: true,
    hot: false,
    updateDate: "2026-07-10",
  },
  {
    id: 7,
    title: "庆余年第二季",
    originalTitle: "Joy of Life Season 2",
    category: "tv",
    genres: ["古装", "剧情", "武侠"],
    region: "中国大陆",
    year: "2024",
    rating: 9.0,
    duration: "36集",
    director: "孙皓",
    actors: ["张若昀", "李沁", "陈道明"],
    poster: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20TV%20series%20poster%2C%20handsome%20man%20in%20ancient%20Chinese%20robe%20holding%20sword%2C%20palace%20background%2C%20elegant%20and%20mysterious%2C%20gold%20and%20deep%20red%20color%20scheme%2C%20cinematic%20period%20drama%20poster&width=600&height=800&seq=movie-poster-07&orientation=portrait",
    description: "范闲从北齐归来后，发现京都暗流涌动，各方势力蠢蠢欲动。面对更加复杂的朝堂局势和武林纷争，范闲将如何运用自己的智慧，守护所爱之人？",
    featured: false,
    hot: true,
    updateDate: "2026-07-31",
  },
  {
    id: 8,
    title: "繁花",
    originalTitle: "Blossoms Shanghai",
    category: "tv",
    genres: ["剧情", "爱情"],
    region: "中国大陆",
    year: "2023",
    rating: 9.3,
    duration: "30集",
    director: "王家卫",
    actors: ["胡歌", "马伊琍", "唐嫣"],
    poster: "https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20TV%20series%20poster%2C%20elegant%20man%20in%201990s%20Shanghai%20style%20suit%2C%20neon%20lights%20of%20old%20Shanghai%20at%20night%2C%20retro%20vibe%2C%20warm%20golden%20tones%2C%20artistic%20cinematic%20poster&width=600&height=800&seq=movie-poster-08&orientation=portrait",
    description: "九十年代的上海，阿宝凭借自己的智慧和努力，在商海中摸爬滚打，从一个默默无闻的小人物成为了上海滩的风云人物。这是一个关于时代、机遇和人生的故事。",
    featured: false,
    hot: false,
    updateDate: "2026-07-18",
  },
  {
    id: 9,
    title: "乘风2026",
    originalTitle: "Ride the Wind 2026",
    category: "variety",
    genres: ["音乐", "真人秀"],
    region: "中国大陆",
    year: "2026",
    rating: 8.3,
    duration: "12期",
    director: "",
    actors: ["宁静", "那英", "王心凌"],
    poster: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20group%20of%20female%20celebrities%20on%20stage%20with%20spotlights%2C%20glamorous%20and%20energetic%2C%20music%20competition%20theme%2C%20purple%20and%20gold%20stage%20lighting%2C%20entertainment%20show%20poster&width=600&height=800&seq=movie-poster-09&orientation=portrait",
    description: "全新一季的女性音乐竞演真人秀，邀请多位实力女艺人同台竞技，展现女性力量与音乐魅力，为观众带来一场视听盛宴。",
    featured: false,
    hot: true,
    updateDate: "2026-07-22",
  },
  {
    id: 10,
    title: "哈哈哈哈哈第五季",
    originalTitle: "Hahahahaha Season 5",
    category: "variety",
    genres: ["喜剧", "真人秀"],
    region: "中国大陆",
    year: "2026",
    rating: 8.1,
    duration: "10期",
    director: "",
    actors: ["邓超", "陈赫", "鹿晗"],
    poster: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20variety%20show%20poster%2C%20group%20of%20male%20celebrities%20laughing%20together%20outdoors%2C%20road%20trip%20theme%2C%20bright%20sunny%20day%2C%20fun%20and%20casual%20vibe%2C%20colorful%20and%20lively%20poster&width=600&height=800&seq=movie-poster-10&orientation=portrait",
    description: "五哈团再次出发！这一季他们将前往更多有趣的地方，体验不同的人文风情，在旅途中收获欢笑与感动。",
    featured: false,
    hot: false,
    updateDate: "2026-07-12",
  },
  {
    id: 11,
    title: "鬼灭之刃 柱训练篇",
    originalTitle: "Demon Slayer: Hashira Training Arc",
    category: "anime",
    genres: ["动画", "动作", "奇幻"],
    region: "日本",
    year: "2024",
    rating: 9.0,
    duration: "8集",
    director: "外崎春雄",
    actors: ["花江夏树", "鬼头明里", "下野纮"],
    poster: "https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20style%2C%20young%20warrior%20with%20katana%20in%20traditional%20Japanese%20setting%2C%20dynamic%20action%20composition%2C%20cherry%20blossoms%2C%20vibrant%20colors%2C%20anime%20art%20style%2C%20clean%20background&width=600&height=800&seq=movie-poster-11&orientation=portrait",
    description: "炭治郎等人为了迎接与鬼舞辻无惨的最终决战，开始了严酷的柱训练。每一位柱都将亲自指导他们，帮助他们突破极限，变得更加强大。",
    featured: false,
    hot: false,
    updateDate: "2026-07-08",
  },
  {
    id: 12,
    title: "间谍过家家 第三季",
    originalTitle: "Spy x Family Season 3",
    category: "anime",
    genres: ["动画", "喜剧", "动作"],
    region: "日本",
    year: "2025",
    rating: 9.1,
    duration: "12集",
    director: "古桥一浩",
    actors: ["江口拓也", "种崎敦美", "早见沙织"],
    poster: "https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%2C%20spy%20family%20of%20three%20in%20elegant%20clothing%2C%20father%20in%20suit%20mother%20in%20dress%20and%20cute%20daughter%2C%20action%20comedy%20theme%2C%20warm%20and%20stylish%2C%20anime%20art%20with%20soft%20colors&width=600&height=800&seq=movie-poster-12&orientation=portrait",
    description: "福杰一家的故事继续！洛伊德接到了新的任务，约尔和安妮亚也各自面临着新的挑战。这个虚假的家庭中，真正的羁绊正在不断加深。",
    featured: false,
    hot: false,
    updateDate: "2026-07-05",
  },
  {
    id: 13,
    title: "消失的她",
    originalTitle: "Lost in the Stars",
    category: "movie",
    genres: ["悬疑", "犯罪", "剧情"],
    region: "中国大陆",
    year: "2023",
    rating: 8.7,
    duration: "122分钟",
    director: "崔睿",
    actors: ["朱一龙", "倪妮", "文咏珊"],
    poster: "https://readdy.ai/api/search-image?query=Chinese%20mystery%20thriller%20movie%20poster%2C%20woman%20disappearing%20into%20darkness%2C%20mysterious%20and%20suspenseful%20atmosphere%2C%20deep%20blue%20and%20black%20tones%2C%20psychological%20thriller%20aesthetic%2C%20cinematic%20poster%20design&width=600&height=800&seq=movie-poster-13&orientation=portrait",
    description: "何非的妻子在海外旅行中神秘失踪，当他报案后，一个陌生女人突然出现，声称自己就是他的妻子。何非开始了一场寻找真相的艰难旅程。",
    featured: false,
    hot: true,
    updateDate: "2026-07-19",
  },
  {
    id: 14,
    title: "八角笼中",
    originalTitle: "Octagonal",
    category: "movie",
    genres: ["剧情", "动作", "运动"],
    region: "中国大陆",
    year: "2023",
    rating: 8.6,
    duration: "117分钟",
    director: "王宝强",
    actors: ["王宝强", "陈永胜", "史彭元"],
    poster: "https://readdy.ai/api/search-image?query=Chinese%20sports%20drama%20movie%20poster%2C%20young%20fighters%20training%20in%20octagonal%20cage%2C%20gritty%20realistic%20style%2C%20rural%20China%20setting%2C%20inspiring%20underdog%20story%2C%20warm%20earthy%20tones&width=600&height=800&seq=movie-poster-14&orientation=portrait",
    description: "向腾辉倾注全部心血，培养大山里的孩子们通过格斗找到人生出路。然而随着往日表演视频被曝光，不明真相的舆论风暴席卷而来。",
    featured: false,
    hot: false,
    updateDate: "2026-07-14",
  },
  {
    id: 15,
    title: "与凤行",
    originalTitle: "The Legend of Shen Li",
    category: "tv",
    genres: ["古装", "奇幻", "爱情"],
    region: "中国大陆",
    year: "2024",
    rating: 8.4,
    duration: "39集",
    director: "邓科",
    actors: ["赵丽颖", "林更新"],
    poster: "https://readdy.ai/api/search-image?width=600&height=800&seq=movie-poster-15&orientation=portrait&query=Chinese%20fantasy%20romance%20drama%20poster%2C%20beautiful%20couple%20in%20ancient%20Chinese%1B%20mythological%20costumes%2C%20phoenix%20theme%2C%20ethereal%20clouds%20and%20golden%20light%2C%20romantic%20and%20magical%20atmosphere%2C%20elegant%20poster",
    description: "灵界碧苍王沈璃因逃婚而坠落人间，在凡间遇到了神秘男子行止。两人在相处中渐生情愫，然而一场跨越三界的浩劫即将来临。",
    featured: false,
    hot: false,
    updateDate: "2026-07-17",
  },
  {
    id: 16,
    title: "长安三万里",
    originalTitle: "Chang An",
    category: "anime",
    genres: ["动画", "历史", "剧情"],
    region: "中国大陆",
    year: "2023",
    rating: 9.0,
    duration: "168分钟",
    director: "谢君伟",
    actors: ["杨天翔", "凌振赫", "吴俊全"],
    poster: "https://readdy.ai/api/search-image?query=Chinese%20historical%20animation%20movie%20poster%2C%20ancient%20Tang%20Dynasty%20cityscape%20of%20Chang%20An%2C%20poets%20in%20traditional%20robes%2C%20Chinese%20ink%20painting%20aesthetic%2C%20golden%20and%20warm%20tones%2C%20artistic%20cinematic%20poster&width=600&height=800&seq=movie-poster-16&orientation=portrait",
    description: "安史之乱爆发后数年，吐蕃大军攻打西南。大唐节度使高适交战不利，困守孤城之际，回忆起了自己与李白跨越数十年的深厚情谊。",
    featured: false,
    hot: false,
    updateDate: "2026-07-06",
  },
];

export const heroSlides = [
  {
    id: 1,
    movieId: 1,
    title: "流浪地球3",
    subtitle: "人类命运共同体，踏上星际征程",
    bgImage: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20scene%2C%20massive%20spaceship%20engines%20on%20Earth%20surface%2C%20astronauts%20looking%20at%20distant%20galaxy%2C%20cinematic%20lighting%2C%20dramatic%20orange%20and%20deep%20space%20blue%2C%20blockbuster%20movie%20aesthetic%2C%20epic%20scale%2C%20photorealistic&width=1920&height=900&seq=hero-slide-01&orientation=landscape",
  },
  {
    id: 2,
    movieId: 2,
    title: "哪吒之魔童闹海",
    subtitle: "我命由我不由天，再战乾坤",
    bgImage: "https://readdy.ai/api/search-image?query=Chinese%20mythological%20animated%20movie%20scene%2C%20young%20warrior%20with%20flaming%20powers%20flying%20through%20stormy%20sky%2C%20epic%20battle%20with%20sea%20monsters%2C%20vibrant%20red%20and%20gold%20colors%2C%20dramatic%20dynamic%20composition%2C%20cinematic&width=1920&height=900&seq=hero-slide-02&orientation=landscape",
  },
  {
    id: 3,
    movieId: 6,
    title: "三体",
    subtitle: "宇宙闪烁，文明重启的倒计时",
    bgImage: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20drama%20scene%2C%20mysterious%20cosmic%20phenomenon%20with%20three%20suns%20in%20alien%20sky%2C%20ancient%20civilization%20ruins%2C%20atmospheric%20and%20mysterious%2C%20deep%20space%20background%2C%20cinematic%20scale%2C%20contemplative%20mood&width=1920&height=900&seq=hero-slide-03&orientation=landscape",
  },
];

export const siteStats = {
  totalMovies: "10000+",
  totalTvShows: "5000+",
  totalVariety: "3000+",
  totalAnime: "2000+",
  dailyVisitors: "50万+",
};

export const testimonials = [
  {
    id: 1,
    name: "影迷小王",
    avatar: "https://readdy.ai/api/search-image?query=Chinese%20young%20man%20portrait%20avatar%2C%20casual%20style%2C%20friendly%20smile%2C%20clean%20light%20background%2C%20professional%20headshot&width=100&height=100&seq=avatar-01&orientation=squarish",
    content: "天堂影院真的太好用了！资源更新快，画质高清，找电影再也不用到处跑了。强烈推荐给所有影迷朋友们！",
    rating: 5,
  },
  {
    id: 2,
    name: "剧集达人",
    avatar: "https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20avatar%2C%20modern%20style%2C%20warm%20smile%2C%20clean%20light%20background%2C%20professional%20headshot&width=100&height=100&seq=avatar-02&orientation=squarish",
    content: "分类特别清晰，电视剧更新速度杠杠的。每天下班回家第一件事就是打开天堂影院追剧，已经成为习惯了。",
    rating: 5,
  },
  {
    id: 3,
    name: "动漫控阿杰",
    avatar: "https://readdy.ai/api/search-image?query=Chinese%20teenage%20boy%20portrait%20avatar%2C%20casual%20hoodie%2C%20friendly%20expression%2C%20clean%20light%20background%2C%20headshot%20photo&width=100&height=100&seq=avatar-03&orientation=squarish",
    content: "动漫资源超级全！日漫国漫都有，而且更新速度一点不输专业动漫网站。天堂影院yyds！",
    rating: 5,
  },
];

export const faqs = [
  {
    id: 1,
    question: "天堂影院是否需要注册才能观看？",
    answer: "天堂影院完全免费，无需注册即可在线观看所有影视资源。我们致力于为用户提供最便捷的观影体验。",
  },
  {
    id: 2,
    question: "天堂影院的影视资源更新频率如何？",
    answer: "我们的资源库每日更新，热门电影和电视剧会在上映后第一时间上线，确保您不会错过任何精彩内容。",
  },
  {
    id: 3,
    question: "天堂影院支持哪些设备观看？",
    answer: "天堂影院支持电脑、平板、手机等多种设备在线观看，无需下载任何软件或插件，打开浏览器即可畅享高清影视。",
  },
  {
    id: 4,
    question: "天堂影院的画质如何？",
    answer: "我们提供高清画质影视资源，采用先进的视频编码技术，确保观影流畅不缓冲，为您带来极致的视觉体验。",
  },
  {
    id: 5,
    question: "天堂影院的内容是否合法？",
    answer: "天堂影院严格遵守相关法律法规，所有内容均来自正版授权渠道，用户可放心观看。",
  },
];

export const contactInfo = {
  email: "contact@tiantangcinema.com",
  wechat: "天堂影院官方",
  weibo: "@天堂影院",
  address: "北京市朝阳区建国路88号",
  phone: "400-888-0000",
};

export const aboutInfo = {
  brandName: "天堂影院",
  slogan: "免费在线看大片，高清流畅不缓冲",
  founded: "2020年",
  mission: "为全球华语用户提供最优质的免费在线观影体验，让每一个人都能轻松享受影视的魅力。",
  introduction: "天堂影院成立于2020年，是国内领先的免费在线影视资源平台。我们致力于打造一个内容丰富、体验流畅的在线影院，涵盖电影、电视剧、综艺、动漫等多种类型，满足不同用户的观影需求。经过多年的发展，天堂影院已经积累了海量的影视资源，拥有超过50万日活跃用户，成为了华语地区最受欢迎的免费影视网站之一。",
  values: [
    { title: "内容为王", description: "我们坚持提供最新、最全、最高清的影视内容，让用户第一时间看到想看的影视作品。" },
    { title: "用户至上", description: "以用户体验为核心，持续优化播放技术和界面设计，确保观影流畅无阻。" },
    { title: "免费初心", description: "始终坚持免费服务，让每一个热爱影视的人都能无门槛享受精彩内容。" },
    { title: "创新进取", description: "不断追求技术创新，引入最新的视频编码和传输技术，提升观影品质。" },
  ],
};